// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"Greetings_Emoji__1aZ-Z","Loading":"Greetings_Loading__LfLiQ","WaitMessage":"Greetings_WaitMessage__1zX43","QuoteMessage":"Greetings_QuoteMessage__pNZ19"};